<template>
    <div class="toggle-route-wrapper">
        <div class="d-flex align-items-center gap-2">
            <h5 class="fs-5 mb-1">Select a tyre fitting method</h5>
            <div @click="toggleInfoModal" data-bs-toggle="modal" data-bs-target="#infoModal">
                <i
                    ref="ffToggle"
                    class="cursor-pointer fa-regular fa-circle-question d-inline-block ms-lg-2"
                ></i>
            </div>
        </div>
        <div class="align-items-center d-flex gap-3">
            <div class="form-check d-inline-block ps-0 ps-sm-2 ps-md-0">
                <input class="form-check-input float-start mx-2 cursor-pointer" id="fullyFittedRadio" name="fittingType" type="radio" @change="toggleRoute(0)" :checked="!toggledHomeDelivery">
                <label class="form-check-label float-start cursor-pointer me-sm-4" for="fullyFittedRadio">Fully fitted</label>
                <input class="form-check-input float-start mx-2 cursor-pointer" id="homeDeliveryRadio" name="fittingType" type="radio" @change="toggleRoute(1)" :checked="toggledHomeDelivery">
                <label class="form-check-label float-start cursor-pointer" for="homeDeliveryRadio">Tyre delivery</label>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['homeDelivery'],
        components: {

        },
        data() {
            return {
                toggledHomeDelivery: this.homeDelivery,
            }
        },
        methods: {
            toggleInfoModal() {
                var heading = 'Fitting method';
                var text = '<p>Fully fitted - Fully fitted price includes VAT, delivery, fitting and balancing.</p><p>Tyre delivery - delivered to your home or work in 3-5 working days. Delivery cost calculated at the basket.</p>';

                this.emitter.emit('openInfoModal', {heading: heading, text: text});
            },
            toggleRoute: function(data) {
                let vm = this;
                axios.post('/ajax/toggle_home_delivery_route/' + data)
                .then(response => {
                    vm.$emit('rangeRouteToggled', data);
                })
                .catch(error => {
                    console.error("There was an error!", error);
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '@frontendAssets/sass/_variables.scss';
    .toggle-route-wrapper {
    h5 {
        font-size: 17px;
        margin: 0;
    }
    .form-switch .form-check-input {
        background-color: $green;
        border-color: $green;
        background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba(255,255,255,1.0)'/></svg>");
    }
    .form-switch .form-check-input:focus {
        border-color: rgba(0, 0, 0, 0.25);
        border: none;
        outline: 0;
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
        background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba(255,255,255,1.0)'/></svg>");
    }
    .form-switch .form-check-input:checked {
        background-color: $green;
        border-color: $green;
        border: none;
        background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba(255,255,255,1.0)'/></svg>");
    }
}
</style>